/* Sean24 Events 1.6: API gateway transport and explicit network diagnostics. */
(function () {
  'use strict';
  if (window.__s24Relay) return;
  window.__s24Relay = true;
  var script = document.currentScript;
  var endpoint = script && script.dataset.endpoint;
  if (!endpoint || !window.fetch || !window.crypto) return;
  var nativeFetch = window.fetch.bind(window), KEY = 's24_relay_v1', PENDING = 's24_native_add_v1';
  var landing = new URL(location.href), entered = Date.now(), record = null, config = null;
  var working = false, syncAgain = false, active = false, installed = false, viewed = false, counts = {}, cartSnapshotReady=false, epoch = 0;
  var OUTBOX='s24_event_v1:', outbox={}, draining=false, retryTimer=null, retryDelay=2000;
  var nativeSubmission=null;
  var initTimer=null, initDelay=2000, initializing=false, privacyLoading=false, booting=false;
  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  function debug(message) {
    if(landing.searchParams.get('s24_debug')!=='1')return;
    var panel=document.getElementById('s24-relay-diagnostic');
    if(!panel){panel=document.createElement('aside');panel.id='s24-relay-diagnostic';panel.setAttribute('role','status');panel.style.cssText='position:fixed;bottom:12px;left:12px;right:12px;z-index:2147483647;padding:14px;background:#10253b;color:#fff;font:14px/1.5 system-ui;border-radius:8px;box-shadow:0 2px 12px #0005;pointer-events:none';(document.body||document.documentElement).appendChild(panel);}
    panel.textContent='Sean24 测试诊断 · '+message;
  }
  function storageGet(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (_) { return null; } }
  function storageSet(k, v) { try { if (v) localStorage.setItem(k, JSON.stringify(v)); else localStorage.removeItem(k); } catch (_) {} }
  function privacyAllowed() {
    var p = window.Shopify && Shopify.customerPrivacy;
    try{return !!(p && p.analyticsProcessingAllowed() && p.marketingAllowed() && (!p.saleOfDataAllowed || p.saleOfDataAllowed()));}catch(_){return false;}
  }
  function allowed(){return !!(config && config.require_shopify_consent===false) || privacyAllowed();}
  function retryStart() {
    if(initTimer)return;
    initTimer=setTimeout(function(){initTimer=null;bootstrap();},initDelay);
    initDelay=Math.min(30000,initDelay*2);
  }
  async function bootstrap() {
    if(config && config.require_shopify_consent!==false && !privacyAllowed())withdraw();
    if(booting)return;
    booting=true;
    try{
      var fresh=await request('config');
      if(config && config.require_shopify_consent!==fresh.require_shopify_consent)active=false;
      config=fresh;
    }catch(error){
      var reason=error.status?'HTTP '+error.status:error.code==='non_json_response'?'接口返回了网页，配置响应被拦截':error.name==='AbortError'?'请求超时':error instanceof TypeError?'浏览器网络连接失败':'网络请求失败';
      debug('配置连接失败（'+reason+'），正在自动重试。');retryStart();return;
    }finally{booting=false;}
    if(!config.enabled){active=false;clearQueue();updateInputs();debug('服务器回传开关关闭。');return;}
    // Explicit merchant-selected internal development mode needs no privacy SDK.
    if(config.require_shopify_consent===false){start();return;}
    if(window.Shopify && Shopify.customerPrivacy){start();return;}
    debug('Shopify 隐私接口尚未就绪，正在等待重试；尚未采集。');
    if(privacyLoading)return;
    if(!window.Shopify || !Shopify.loadFeatures){retryStart();return;}
    privacyLoading=true;
    // A missing callback must not permanently disable collection for this page.
    var settled=false;
    var watchdog=setTimeout(function(){finish(true);},5000);
    function finish(error){
      if(settled)return;settled=true;clearTimeout(watchdog);privacyLoading=false;
      if(!error && window.Shopify && Shopify.customerPrivacy)start();else retryStart();
    }
    try{Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],finish);}catch(_){finish(true);}
  }
  function id() { return crypto.randomUUID ? crypto.randomUUID() : Array.from(crypto.getRandomValues(new Uint8Array(18)), function (v) { return v.toString(16).padStart(2, '0'); }).join(''); }
  function validBbg(s) { return typeof s === 'string' && /^[A-Za-z0-9_+/=\-]{16,4096}$/.test(s) && !s.includes('__BBG__'); }
  async function request(action, data) {
    var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 5000);
    try {
      var r = await nativeFetch(endpoint + '?action=' + action, {method: data ? 'POST' : 'GET', mode: 'cors', credentials: 'omit', cache: 'no-store', keepalive:action==='event', headers: data ? {'Content-Type': 'application/json','Accept':'application/json'} : {'Accept':'application/json'}, body: data ? JSON.stringify(data) : undefined, signal: controller.signal});
      if (!r.ok) { var error=Error('relay unavailable');error.status=r.status;throw error; }
      try{return await r.json();}catch(_){var parseError=Error('relay did not return JSON');parseError.code='non_json_response';throw parseError;}
    } finally { clearTimeout(timer); }
  }
  function queueKeys() {
    var keys=[];try{for(var i=0;i<localStorage.length;i++){var key=localStorage.key(i);if(key && key.indexOf(OUTBOX)===0)keys.push(key);}}catch(_){}return keys;
  }
  function forget(eventId) { delete outbox[eventId];storageSet(OUTBOX+eventId,null); }
  function clearQueue() { outbox={};queueKeys().forEach(function(k){storageSet(k,null);});if(retryTimer)clearTimeout(retryTimer);retryTimer=null; }
  function loadQueue() {
    queueKeys().forEach(function(k){var e=storageGet(k);if(e && e.id && e.ref && e.pixel===config.pixel_id && e.at>Date.now()/1000-86400 && e.at<=Date.now()/1000+60)outbox[e.id]=e;else storageSet(k,null);});
    Object.keys(outbox).forEach(function(k){if(outbox[k].at<Date.now()/1000-86400 || outbox[k].pixel!==config.pixel_id)forget(k);});
  }
  function scheduleRetry() {
    if(retryTimer || !active || !allowed())return;
    retryTimer=setTimeout(function(){retryTimer=null;drain();},retryDelay);retryDelay=Math.min(60000,retryDelay*2);
  }
  async function drain() {
    if(draining || !active || !allowed() || !config || !config.enabled)return;
    draining=true;var stamp=epoch;
    try{
      loadQueue();
      for(var i=0;i<50;i++){
        if(!active || !allowed() || stamp!==epoch)break;
        var keys=Object.keys(outbox).sort(function(a,b){return outbox[a].at-outbox[b].at;});
        var e=outbox[keys[0]];if(!e)break;
        try{
          var result=await request('event',{id:e.id,event:e.event,ref:e.ref,occurred_at:e.at});
          if(result.queued){forget(e.id);retryDelay=2000;debug('服务器已接收 '+e.event+'。BIGO 是否接受需核对服务器记录。');}
          else if(result.enabled===false){active=false;clearQueue();break;}
          else{scheduleRetry();break;}
        }catch(error){
          debug('发送暂未成功'+(error.status?'（HTTP '+error.status+'）':'（网络错误）')+'；可保留此页核对。');
          if(error.status===400 || error.status===410){forget(e.id);continue;}
          scheduleRetry();break;
        }
      }
    }finally{draining=false;if(Object.keys(outbox).length)scheduleRetry();}
  }
  function event(type) {
    if(!active || !allowed() || !record)return;
    loadQueue();if(Object.keys(outbox).length>=200)return;
    var e={id:id(),event:type,ref:record.ref,pixel:config.pixel_id,at:Math.floor(Date.now()/1000)};
    outbox[e.id]=e;storageSet(OUTBOX+e.id,e);drain();
  }
  function cartPath(input) { try { var u = new URL(typeof input === 'string' ? input : input.url, location.origin); return u.origin === location.origin ? u.pathname : ''; } catch (_) { return ''; } }
  function updateInputs() {
    document.querySelectorAll('form[action]').forEach(function (form) {
      var path = cartPath(form.action), name = /\/cart\/add(?:\.js)?\/?$/.test(path) ? 'properties[_s24_ref]' : /\/cart\/?$/.test(path) ? 'attributes[_s24_ref]' : '';
      if (!name) return;
      var input = form.querySelector('input[data-s24-ref]');
      if (!active || !record) { if (input) input.remove(); return; }
      if (!input) { input = document.createElement('input'); input.type='hidden'; input.name=name; input.dataset.s24Ref='1'; form.appendChild(input); }
      if (input.value !== record.ref) input.value=record.ref;
    });
  }
  function quantities(cart) { var result={}; (cart.items || []).forEach(function (i) { result[String(i.variant_id)] = (result[String(i.variant_id)] || 0) + i.quantity; }); return result; }
  async function syncCart() {
    if (!active || !record || !allowed()) return;
    if (working) { syncAgain=true; return; }
    working=true;var stamp=epoch, ref=record.ref;
    try {
      var response=await nativeFetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)return;var cart=await response.json();
      if(!active || stamp!==epoch)return;
      counts=quantities(cart);cartSnapshotReady=true;
      var pending;try{pending=JSON.parse(sessionStorage.getItem(PENDING));sessionStorage.removeItem(PENDING);}catch(_){}
      if(pending && Date.now()-pending.at<120000 && pending.variant && (counts[pending.variant]||0)>(pending.before||0))event('ec_add_cart');
      if ((cart.attributes || {})._s24_ref !== ref) {
        await nativeFetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{_s24_ref:ref}})});
      }
      if(active && stamp===epoch && allowed())await request('bind',{ref:ref,cart_token:cart.token});
    } catch (_) { /* Shopping continues when attribution is unavailable. */ }
    finally {working=false;if(syncAgain){syncAgain=false;syncCart();}}
  }
  function install() {
    if(installed)return;installed=true;
    window.fetch=function (input, init) {
      var path=cartPath(input), add=/\/cart\/add(?:\.js)?\/?$/.test(path), change=/\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(path);
      if(add)nativeSubmission=null;
      return nativeFetch(input,init).then(function(response){
        if(active && allowed() && change && response.ok){
          if(add){response.clone().json().then(function(body){if(!body.status && (body.id || (body.items && body.items.length)))event('ec_add_cart');}).catch(function(){});}
          syncCart();
        }
        return response;
      });
    };
    var open=XMLHttpRequest.prototype.open, send=XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open=function(method,url){this.__s24path=cartPath(String(url));return open.apply(this,arguments);};
    XMLHttpRequest.prototype.send=function(){
      if(/\/cart\/add(?:\.js)?\/?$/.test(this.__s24path||''))nativeSubmission=null;
      this.addEventListener('load',function(){
        if(!active || !allowed() || this.status<200 || this.status>=300)return;
        if(/\/cart\/add(?:\.js)?\/?$/.test(this.__s24path||'')){
          try{var body=this.responseType==='json'?this.response:JSON.parse(this.responseText);if(!body.status && (body.id || (body.items && body.items.length)))event('ec_add_cart');}catch(_){}
        }
        if(/\/cart\/(?:add|change|update|clear)(?:\.js)?\/?$/.test(this.__s24path||''))syncCart();
      },{once:true});return send.apply(this,arguments);
    };
    document.addEventListener('submit',function(e){
      if(!active || !allowed() || !e.target.matches('form'))return;
      updateInputs();var form=e.target;
      if(/\/cart\/add(?:\.js)?\/?$/.test(cartPath(form.action))){
        var variant=new FormData(form).get('id');
        // Capture listeners can run a microtask before the theme cancels submit.
        // Decide only on page exit, after dispatch; AJAX owns its own success signal.
        nativeSubmission=cartSnapshotReady?{submit:e,variant:String(variant),before:counts[String(variant)]||0,at:Date.now()}:null;
      }
    },true);
    var scheduled=false;
    new MutationObserver(function(){if(scheduled)return;scheduled=true;queueMicrotask(function(){scheduled=false;updateInputs();});}).observe(document.documentElement,{childList:true,subtree:true});
    window.addEventListener('pagehide',function(){
      var pending=nativeSubmission;nativeSubmission=null;
      if(active && allowed() && pending && !pending.submit.defaultPrevented && Date.now()-pending.at<10000){
        try{sessionStorage.setItem(PENDING,JSON.stringify({variant:pending.variant,before:pending.before,at:pending.at}));}catch(_){}
      }
      drain();
    });
    window.addEventListener('storage',function(e){if(e.key && e.key.indexOf(OUTBOX)===0){if(e.newValue===null)delete outbox[e.key.slice(OUTBOX.length)];else drain();}});
  }
  async function withdraw() {
    if(initTimer)clearTimeout(initTimer);initTimer=null;
    nativeSubmission=null;try{sessionStorage.removeItem(PENDING);}catch(_){}
    var refs={};queueKeys().forEach(function(k){var e=storageGet(k);if(e && e.ref)refs[e.ref]=true;});Object.keys(outbox).forEach(function(k){refs[outbox[k].ref]=true;});clearQueue();
    active=false;epoch++;var old=record || storageGet(KEY);record=null;storageSet(KEY,null);updateInputs();
    if(old && old.ref)refs[old.ref]=true;Object.keys(refs).forEach(function(ref){request('revoke',{ref:ref}).catch(function(){});});
    // Clear our own attribute only; preserve all merchant attributes.
    if(old && old.ref)nativeFetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{_s24_ref:''}})}).catch(function(){});
  }
  async function start() {
    if(!allowed()){debug('未满足店铺的分析／营销隐私许可，未采集。请按你的真实意愿选择 Cookie 设置。');withdraw();return;}
    if(initializing)return;
    if(active && record && record.expires*1000>Date.now()){drain();return;}
    if(initTimer)clearTimeout(initTimer);initTimer=null;
    initializing=true;active=false;updateInputs();
    var stamp=++epoch;
    try{
      debug('正在连接回传服务器…');
      if(stamp!==epoch || !allowed())return;
      if(!config.enabled){active=false;clearQueue();updateInputs();debug('服务器回传开关关闭。');return;}
      var bbg=landing.searchParams.get('bbg')||landing.searchParams.get('my_bbg'), pixel=landing.searchParams.get('pixel_id')||landing.searchParams.get('my_pixel_id');
      if(pixel && pixel!==config.pixel_id){debug('链接的 Pixel ID 不匹配，或 __PIXEL_ID__ 尚未替换。应为 '+config.pixel_id+'。');return;}
      var explicitBbg=landing.searchParams.has('bbg')||landing.searchParams.has('my_bbg');
      if(explicitBbg && !validBbg(bbg)){debug('链接中的 BBG 为空、格式无效或仍是占位符。需要 BIGO 生成的实际测试链接；本次不会套用旧点击。');return;}
      var saved=storageGet(KEY);
      if(saved && (saved.expires*1000<Date.now() || saved.pixel!==config.pixel_id))saved=null;
      if(!validBbg(bbg) || Date.now()-entered>=86400000)bbg=saved && saved.bbg;
      if(!validBbg(bbg)){debug('没有有效 BBG，也没有可复用的广告关联。普通商品链接本身不能生成 BBG。');return;}
      debug(explicitBbg?'已取得链接中的有效格式 BBG，正在建立关联…':'正在使用此前保存的广告点击关联；这不是新的测试点击。');
      var result=await request('attribution',{bbg:bbg,pixel_id:config.pixel_id,ref:saved && saved.bbg===bbg?saved.ref:'',consent:privacyAllowed(),url:landing.origin+landing.pathname});
      if(stamp!==epoch || !allowed()){if(result.ref)request('revoke',{ref:result.ref}).catch(function(){});return;}
      if(!result.ref){debug('服务器没有返回广告关联，尚不能回传事件。');return;}
      record={ref:result.ref,expires:result.expires,bbg:bbg,pixel:config.pixel_id};storageSet(KEY,record);active=true;
      initDelay=2000;
      install();updateInputs();drain();syncCart();
      if(!viewed){viewed=true;event('page_view');if(script.dataset.product==='true')event('ec_detail_view');}
    }catch(_){
      if(stamp===epoch && allowed()){
        debug('初始化连接暂时失败，正在自动重试。购物功能不受影响。');retryStart();
      }
    }finally{initializing=false;}
  }
  // Recovery hooks must exist even when the very first request failed.
  document.addEventListener('visitorConsentCollected',bootstrap);
  window.addEventListener('online',bootstrap);
  window.addEventListener('pageshow',function(e){if(e.persisted)bootstrap();});
  document.addEventListener('visibilitychange',function(){if(document.visibilityState==='visible')bootstrap();});
  bootstrap();
})();
